import React from 'react';
import { Outlet } from 'react-router-dom';

import { WhiteWaypointLogo } from '@dashboard/components/WaypointLogo';
import { AppBar, Button, Container, Toolbar } from '@mui/material';

export default function UnauthenticatedPageLayout() {
  return (
    <>
      <AppBar position="static">
        <Container>
          <Toolbar
            disableGutters
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <WhiteWaypointLogo />
            <Button href="https://usewaypoint.com/help" target="_blank" color="inherit">
              Help
            </Button>
          </Toolbar>
        </Container>
      </AppBar>
      <Container sx={{ py: 4 }}>
        <Outlet />
      </Container>
    </>
  );
}
